import { createServerFn } from "@tanstack/react-start";

async function cacheHeader() {
  const { setResponseHeader } = await import("@tanstack/react-start/server");
  setResponseHeader(
    "cache-control",
    "public, max-age=300, stale-while-revalidate=3600",
  );
}

export const fetchCategoryHub = createServerFn({ method: "GET" })
  .inputValidator((data: { category: string; subcategory?: string | null }) => data)
  .handler(async ({ data }) => {
    await cacheHeader();
    const { getCategoryHub } = await import("./library-hubs.server");
    return getCategoryHub(data.category, data.subcategory ?? null);
  });

export const fetchTagHub = createServerFn({ method: "GET" })
  .inputValidator((data: { tag: string }) => data)
  .handler(async ({ data }) => {
    await cacheHeader();
    const { getTagHub } = await import("./library-hubs.server");
    return getTagHub(data.tag);
  });

export const fetchLibraryTaxonomy = createServerFn({ method: "GET" }).handler(
  async () => {
    await cacheHeader();
    const { getTaxonomy } = await import("./library-hubs.server");
    return getTaxonomy();
  },
);

export const fetchNewestGems = createServerFn({ method: "GET" }).handler(
  async () => {
    await cacheHeader();
    const { getNewestGems } = await import("./library-hubs.server");
    return getNewestGems(60);
  },
);

export const fetchCreatorHub = createServerFn({ method: "GET" })
  .inputValidator((data: { creator: string }) => data)
  .handler(async ({ data }) => {
    await cacheHeader();
    const { getCreatorHub } = await import("./library-hubs.server");
    return getCreatorHub(data.creator);
  });

export const fetchCreatorDirectory = createServerFn({ method: "GET" }).handler(
  async () => {
    await cacheHeader();
    const { getCreatorDirectory } = await import("./library-hubs.server");
    return getCreatorDirectory(200);
  },
);
